import { render } from "./FeedbackboardPhonemicConsonant.vue?vue&type=template&id=560acce2&scoped=true"
import script from "./FeedbackboardPhonemicConsonant.vue?vue&type=script&lang=js"
export * from "./FeedbackboardPhonemicConsonant.vue?vue&type=script&lang=js"

import "@/css/components/feedbackboard-phonemic-consonant.css?vue&type=style&index=0&id=560acce2&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560acce2"]])

export default __exports__